<div
  #modalElement
  role="document"
  class="ant-modal"
  (mousedown)="onMousedown()"
  [ngClass]="modalConfig.uiClassName!"
  [ngStyle]="modalConfig.uiStyle!"
  [style.width]="modalConfig?.uiWidth! | nzToCssUnit">
  <div class="ant-modal-content">
    <button *ngIf="modalConfig.uiClosable" ui-modal-close (click)="onCloseClick()"></button>
    <div *ngIf="modalConfig.uiTitle" ui-modal-title></div>
    <div class="ant-modal-body" [ngStyle]="modalConfig.uiBodyStyle!">
      <ng-template cdkPortalOutlet></ng-template>
      <div *ngIf="isStringContent" [innerHTML]="modalConfig.uiContent"></div>
    </div>
    <div *ngIf="modalConfig.uiFooter !== null" ui-modal-footer [modalRef]="modalRef" (cancelTriggered)="onCloseClick()" (okTriggered)="onOkClick()"></div>
  </div>
</div>
